import React, { useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
  Box,
  useTheme,
} from "@mui/material";

interface Props {
  config: any;
  onChange: (field: string, value: any) => void;
}

const VideoDewarpingForm: React.FC<Props> = ({ config, onChange }) => {
  const theme = useTheme();
  const red = theme.palette.status.accent;

  // Always set the default calibration file
  useEffect(() => {
    if (!config.calibration_file) {
      onChange("calibration_file", "CIL220_camera_calib.npz");
    }
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderLeft: `3px solid ${red}`,
        borderRadius: 2,
        p: 2,
        mt: 1,
        boxShadow: "0 0 6px rgba(0,0,0,0.3)",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{
          mb: 2,
          fontWeight: 600,
          color: red,
          letterSpacing: 0.3,
        }}
      >
        Dewarp Undercarriage
      </Typography>

      <Grid container spacing={2}>
        {/* Top Crop */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Top Crop"
            type="number"
            fullWidth
            value={config.crop_top || ""}
            onChange={(e) => onChange("crop_top", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Bottom Crop */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Bottom Crop"
            type="number"
            fullWidth
            value={config.crop_bottom || ""}
            onChange={(e) => onChange("crop_bottom", e.target.value)}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Partial Base Balance Alpha */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Partial Base Balance Alpha"
            type="number"
            fullWidth
            value={config.partial_base_balance_alpha || ""}
            onChange={(e) =>
              onChange("partial_base_balance_alpha", e.target.value)
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Partial Base Scale Heuristic Range */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Partial Base Scale Heuristic Range"
            type="number"
            fullWidth
            value={config.partial_base_scale_heuristic_range || ""}
            onChange={(e) =>
              onChange("partial_base_scale_heuristic_range", e.target.value)
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Partial Correction Strength */}
        <Grid item xs={12} sm={6}>
          <TextField
            label="Partial Correction Strength"
            type="number"
            fullWidth
            value={config.partial_correction_strength || ""}
            onChange={(e) =>
              onChange("partial_correction_strength", e.target.value)
            }
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: red },
                "&.Mui-focused fieldset": { borderColor: red },
              },
            }}
          />
        </Grid>

        {/* Hidden calibration file (read-only) */}
        <Grid item xs={12}>
          <TextField
            label="Calibration File (auto-set)"
            fullWidth
            disabled
            value={config.calibration_file || "CIL220_camera_calib.npz"}
            variant="outlined"
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
              },
              "& .MuiInputBase-input": { color: "#999" },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default VideoDewarpingForm;
